

// Vue, third party
import { Component, Watch, Vue, Mixins, Prop } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import TreeItem from "@/components/TreeView/TreeItem.vue";
import draggable from "vuedraggable"; // @ref https://github.com/SortableJS/Sortable#options
import { TreeView, sortedValue } from "@/types/treeView";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

@Component({
    components: {
        "tree-item": TreeItem,
        draggable,
        "vue-perfect-scrollbar": VuePerfectScrollbar,
    }
})
export default class TreeContainer extends Vue {

    // Array of tree items
    @Prop({ default: () => ([]), type: Array }) items: TreeView[];

    // Draggable enabled/disabled
    @Prop({ default: false, type: Boolean }) disableDrag: boolean = false;

    // expand/collapse tree
    @Prop({ default: false, type: Boolean }) expandTree: boolean = false;

    @Prop({ default: 0, type: Number }) spacing: number;

    @Prop({ default: true, type: Boolean }) sorting: boolean;

    @Prop({ default: false, type: Boolean }) disableTree: boolean;

    @Prop({ default: 0, type: Number }) sortLevel: number;

    // Draggable options
    @Prop({ default: () => ({
        animation: 100,
        disabled: false,
        ghostClass: "action-plan-item-ghost"
    }), type: Object }) actionPlanDragOptions;

    // Current tree level 
    private level: number = 0;
    
    // Remove "items" prop from being changed by re-ordering
    private sortedItems: TreeView[] = this.items;

    @Watch("items")
    private onItemsUpdated(newItems: TreeView[]) {
        this.sortedItems = newItems;
    }        

    /**
     * @summary method to sort current tree and triggers emit method
     * @returns void
     */
    private sortChange(moved: any) {
        if (!this.sorting) return;

        // Set the item's order value to the index they have been set to in the list
        this.sortedItems = this.sortedItems.map((tree: TreeView, index: number) => ({ ...tree, order: index}));

        const sorted: sortedValue = {
          level: this.level,
          previousIndex: moved.oldIndex,
          currentIndex: moved.newIndex,
          item: moved.element,
          tree: [...this.sortedItems.map((item: TreeView, index: number) => (item.id))]
        };
        this.emitSortedValue(sorted);
    }

    /**
     * @summary method emit sorted value
     * @emits sortedValues sorted values
     * @returns void
     */
    private emitSortedValue(value: sortedValue) {
        this.$emit("sorted-value", value);
    }
}
